import { render, staticRenderFns } from "./TemporaryAssistanceAntecipationAddModal.vue?vue&type=template&id=6764345c"
import script from "./TemporaryAssistanceAntecipationAddModal.vue?vue&type=script&lang=js"
export * from "./TemporaryAssistanceAntecipationAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports